"use strict";
require('rxjs/add/operator/let');
require('rxjs/add/operator/scan');
exports.ActionTypes = {
    INIT: '@@ngrx/INIT'
};
var StoreBackend = (function () {
    function StoreBackend(_dispatcher, _reducer, _initialState, _preMiddleware, _postMiddleware) {
        if (_preMiddleware === void 0) { _preMiddleware = function (t) { return t; }; }
        if (_postMiddleware === void 0) { _postMiddleware = function (t) { return t; }; }
        this._dispatcher = _dispatcher;
        this._reducer = _reducer;
        this._initialState = _initialState;
        this._preMiddleware = _preMiddleware;
        this._postMiddleware = _postMiddleware;
    }
    StoreBackend.prototype._init = function () {
        this._dispatcher.dispatch({ type: exports.ActionTypes.INIT });
    };
    StoreBackend.prototype.connect = function (nextCallbackFn) {
        var _this = this;
        this._dispatcher
            .let(this._preMiddleware)
            .scan(function (state, action) { return _this._reducer(state, action); }, this._initialState)
            .let(this._postMiddleware)
            .subscribe(nextCallbackFn);
        this._init();
    };
    StoreBackend.prototype.replaceReducer = function (reducer) {
        this._reducer = reducer;
        this._init();
    };
    return StoreBackend;
}());
exports.StoreBackend = StoreBackend;



/*****************
 ** WEBPACK FOOTER
 ** ./~/@ngrx/store/dist/store-backend.js
 ** module id = 235
 ** module chunks = 0
 **/